<mat-sidenav-container class="sidenav-container">
  <mat-sidenav #drawer class="sidenav" fixedInViewport
      [attr.role]="(isHandset$ | async) ? 'dialog' : 'navigation'"
      [mode]="(isHandset$ | async) ? 'over' : 'side'"
      [opened]="(isHandset$ | async) === false">
    <mat-toolbar color="accent">Menu</mat-toolbar>
    <mat-nav-list>

      <mat-list-item>
        <mat-icon matListIcon>dashboard</mat-icon>
        <a mat-list-item href="/dashboard">Dashboard</a>
      </mat-list-item>

      <mat-list-item>
        <mat-icon matListIcon>home</mat-icon>
        <a mat-list-item href="/home">home</a>
      </mat-list-item>

      <mat-list-item>
        <mat-icon matListIcon>account_circle</mat-icon>
        <a mat-list-item href="/cliente">Cliente</a>
      </mat-list-item>

      <mat-list-item>
        <mat-icon matListIcon>account_box</mat-icon>
        <a mat-list-item href="/useraccount">Mi Perfil</a>
      </mat-list-item>

      <mat-list-item>
        <mat-icon matListIcon>assignment</mat-icon>
        <a mat-list-item href="/miactividad">Mi Actividad</a>
      </mat-list-item>

      <mat-list-item>
        <mat-icon matListIcon>login</mat-icon>
        <a mat-list-item href="/login">login</a>
      </mat-list-item>

      <mat-list-item>
        <mat-icon matListIcon>support_agent</mat-icon>
        <a mat-list-item href="/soporte">Soporte</a>
      </mat-list-item>

      
      

      

    </mat-nav-list>
  </mat-sidenav>
  <mat-sidenav-content>
    <mat-toolbar color="primary">
      <button
        type="button"
        aria-label="Toggle sidenav"
        mat-icon-button
        (click)="drawer.toggle()"
        *ngIf="isHandset$ | async">
        <mat-icon aria-label="Side nav toggle icon">menu</mat-icon>
      </button>
      <span>app</span>
    </mat-toolbar>
    <!-- Add Content Here -->
    <ng-content></ng-content>
  </mat-sidenav-content>
</mat-sidenav-container>
